import dayjs from "dayjs";

export type PromoStatusCode = {
  codevalue?: string | number;
  codedisplayname?: string;
};

export function pickPromoExpiryRaw(item: Record<string, unknown>): unknown {
  return (
    item.expirydate ??
    item.expiryDate ??
    item.enddate ??
    item.endDate ??
    item.validto ??
    item.validTo
  );
}

export function pickPromoStartRaw(item: Record<string, unknown>): unknown {
  return (
    item.startdate ??
    item.startDate ??
    item.validfrom ??
    item.validFrom
  );
}

/**
 * True when today is past the validity window (end date is inclusive through that day).
 * Not expired when today is within [start, end], including the expiry date itself.
 */
export function isPromoExpiredByExpiryDate(
  item: Record<string, unknown>,
): boolean {
  const today = dayjs().startOf("day");

  const startRaw = pickPromoStartRaw(item);
  if (startRaw != null && String(startRaw).trim() !== "") {
    const start = dayjs(String(startRaw).trim()).startOf("day");
    if (start.isValid() && today.isBefore(start)) {
      return false;
    }
  }

  const endRaw = pickPromoExpiryRaw(item);
  if (endRaw == null || String(endRaw).trim() === "") return false;
  const expiry = dayjs(String(endRaw).trim()).startOf("day");
  if (!expiry.isValid()) return false;
  return today.isAfter(expiry);
}

export function statusCodeValueFromApi(item: Record<string, unknown>): string {
  const raw = item.status ?? item.promoStatus ?? item.promostatus;
  if (raw === undefined || raw === null) return "";
  return String(raw).trim();
}

/** API status, or Expired code when today is after the inclusive end date. */
export function resolvePromoStatusCodeValue(
  item: Record<string, unknown>,
  expiredStatusCodeValue?: string,
): string {
  if (expiredStatusCodeValue && isPromoExpiredByExpiryDate(item)) {
    return expiredStatusCodeValue;
  }
  return statusCodeValueFromApi(item);
}

export function findExpiredPromoStatusCodeValue(
  promoStatusCodes: PromoStatusCode[],
): string | undefined {
  const match = promoStatusCodes.find((c) =>
    /expir/i.test(String(c.codedisplayname ?? "")),
  );
  if (match?.codevalue == null || String(match.codevalue).trim() === "") {
    return undefined;
  }
  return String(match.codevalue).trim();
}
